
import { Component, Prop, Vue } from "vue-property-decorator";
import { CardCost } from "../models/Card";

@Component({ components: {} })
export default class CardCostExpandTable extends Vue {
  @Prop() readonly costs!: CardCost[];
}
